(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const slides = [...gallery.querySelectorAll('[data-gallery-main]')];
      const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
      const dialog = gallery.querySelector('[data-gallery-dialog]');
      let index = 0, pointer, suppressClick = false;
      function show(next, focus = false) {
        if (!slides.length) return;
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === index;
          if (!active && slide.classList.contains('is-active')) {
            slide.querySelectorAll('video').forEach(video => video.pause());
            slide.querySelectorAll('iframe').forEach(frame => { const src = frame.getAttribute('src'); if (src) frame.setAttribute('src', src); });
            slide.querySelectorAll('model-viewer').forEach(model => { if (typeof model.pause === 'function') model.pause(); });
          }
          slide.classList.toggle('is-active', active);
          slide.hidden = !active;
        });
        thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-current', String(i === index));
        });
        if (focus) thumbs[index]?.focus();
      }
      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => show(i));
        thumb.addEventListener('keydown', event => {
          const next = { ArrowLeft: i - 1, ArrowRight: i + 1, Home: 0, End: slides.length - 1 }[event.key];
          if (next !== undefined) { event.preventDefault(); show(next, true); }
        });
      });
      const main = gallery.querySelector('.al-gallery__main');
      main.addEventListener('pointerdown', event => {
        suppressClick = false;
        if (event.pointerType !== 'mouse' && event.isPrimary && !event.target.closest('video, iframe, model-viewer')) pointer = { x: event.clientX, y: event.clientY };
      });
      main.addEventListener('pointerup', event => {
        if (!pointer) return;
        const dx = event.clientX - pointer.x, dy = event.clientY - pointer.y;
        pointer = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) { suppressClick = true; show(index + (dx < 0 ? 1 : -1)); }
      });
      main.addEventListener('pointercancel', () => { pointer = null; });
      gallery.querySelectorAll('[data-gallery-zoom]').forEach(link => link.addEventListener('click', event => {
        if (!dialog?.showModal || event.ctrlKey || event.metaKey || event.shiftKey) return;
        event.preventDefault();
        if (suppressClick) { suppressClick = false; return; }
        const image = dialog.querySelector('[data-gallery-enlarged]');
        image.src = link.href;
        image.alt = link.querySelector('img').alt;
        dialog.showModal();
      }));
      dialog?.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      show(0);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
